import React from "react";
import AboutPageComponent from "../../components/AboutPageComponent/AboutPageComponent.jsx";
import Support from "../../components/SuportComponent/support.js";

function Aboutus() {
  return (
    <div>
      <AboutPageComponent />
      <Support />
    </div>
  );
}

export default Aboutus;
